module.exports = "https://static.im-cdn.com/mjc/storefront/Essense/static/media/BannerRightArrow.0ce95d3e.svg";